import React from 'react';
import { classes } from './AccordionSectionItem.st.css';
import Text from '../../../Text';
import { AccordionSectionItemProps } from '../../Accordion.types';

function accordionSectionItem({ title }: AccordionSectionItemProps) {
  return (
    <div className={classes.root}>
      <Text skin="standard" weight="bold" size="small" ellipsis>
        {title}
      </Text>
    </div>
  );
}

export default accordionSectionItem;
